import React from 'react';

const Trash = ({...props}) => (
  <svg viewBox="0 0 24 24"><path d="m6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-12h-12zm13-15h-3.5l-1-1h-5l-1 1h-3.5v2h14z"/></svg>
);

export default Trash;
